/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { DynamicFieldsKanbanWidget } from './libs/KanbanComp';
import * as S from '../../styles';

export interface IDynamicFieldsProps {
    id: string;
    fontScale?: number;

    cardType?: string;
    attributesTitle?: string;
    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: any;
    attributeForm?: ITweetyWidgetProps;
    hiddenFields?: string[];
    cardTitleField?: string;
    required?: boolean;
    totalSections?: number;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
    onDynamicFieldChange?(id: string, payload: any): void;
    _deletemanagerial?(id: any, payload): any;
    cityCall?(id: any, payload): any;
}

export const DynamicFields = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    attributesTitle,
    _deletemanagerial,
    cardType,
    onCompChange,
    hiddenFields,
    cardTitleField,
    hasError,
    attributeForm,
    lookUpField,
    totalSections,
    onDynamicFieldChange,
    cityCall,
}: IDynamicFieldsProps) => {
    const onChange = (id: string, e: any) => {
        if (e && e[0] && e[0]?.cards) {
            onCompChange && onCompChange(id, e[0].cards);
        }
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };
    const [form, setform] = useState(attributeForm);
    console.log('hi->', attributeForm, form);
    console.log('hi->', value, attributesTitle, cardType, attributeForm);

    useEffect(() => {
        if (attributeForm) {
            setform(attributeForm);
        }
    }, [attributeForm]);
    console.log('ki->2', hasError, errorText);
    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <DynamicFieldsKanbanWidget
                        cardType={cardType}
                        cardTitleField={cardTitleField}
                        _deletemanagerial={_deletemanagerial}
                        cityCall={cityCall}
                        hiddenFields={hiddenFields}
                        fontScale={fontScale}
                        kanbanList={[
                            {
                                title: attributesTitle,
                                cards: value ?? [],
                            },
                        ]}
                        onKanbanConfirm={(kanbanLists: any) => {
                            onChange(id, kanbanLists);
                            console.log('ho->heloo', kanbanLists);
                        }}
                        totalSections={totalSections}
                        labelColor={labelColor}
                        attributeForm={form}
                        onDynamicFieldChange={(subId, payload) => {
                            onDynamicFieldChange &&
                                onDynamicFieldChange('dynamicField', {
                                    id,
                                    subId,
                                    payload,
                                });
                        }}
                    />
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

DynamicFields.defaultProps = {
    required: false,
    // attributesTitle: 'Directors',
    // cardType: 'Director',
    hasError: false,
};
